import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getCarpetasFiltros = async (numeroSolicitud, numeroCarpeta,serie,patente,proyecto,estado, numeroInterno) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/carpetas?empresa=${userInfo.empresa}&numeroSolicitud=${numeroSolicitud}&numeroCarpeta=${numeroCarpeta}&serie=${serie}&patente=${patente}&proyecto=${proyecto}&estado=${estado}&numeroInterno=${numeroInterno}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getCarpetasSP = async (serie,patente) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/carpetas/seriepatente?empresa=${userInfo.empresa}&serie=${serie}&patente=${patente}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearCarpeta = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/carpetas', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateCarpeta = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/carpetas/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteCarpeta = (Id) => Axios.delete(`/carpetas/${Id}`);

  export const getCarpetaById = async (id) => {
    try {
      const { data } = await Axios.get(`/carpetas/${id}`);
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getCarpetaEquipo = async (codigoEquipo) => {
    try {
      const userInfo = fetchUser();
      const { data } = await Axios.get(
        `/carpetas/equipo?empresa=${userInfo.empresa}&codigoEquipo=${encodeURIComponent(codigoEquipo)}`
      );
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const marcarSalidaObraCarpeta = async (codigoEquipo) => {
    try {
      const userInfo = fetchUser();
      const { data } = await Axios.patch('/carpetas/salidaObra', {
        empresa: userInfo.empresa,
        codigoEquipo,
      });
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const eliminarEquipo = async ({ idSolicitud, idAsignacion, lineaAsig }) => {
    try {
      const userInfo = fetchUser();
      if (!userInfo) return Promise.reject(new Error('Sesión expirada. Por favor inicie sesión nuevamente.'));
      const { data } = await Axios.post('/carpetas/eliminarequipo', {
        empresa: userInfo.empresa,
        idSolicitud,
        idAsignacion,
        lineaAsig,
      });
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const traspasoEquipo = async (codigoEquipo, idCentroNuevo, marca, modelo, observacion) => {
    try {
      const userInfo = fetchUser();
      if (!userInfo) return Promise.reject(new Error('Sesión expirada. Por favor inicie sesión nuevamente.'));
      const { data } = await Axios.post('/carpetas/traspaso', {
        empresa: userInfo.empresa,
        codigoEquipo,
        idCentroNuevo,
        idUsuario: userInfo.usuario,
        marca:     marca  || '',
        modelo:    modelo || '',
        observacion: observacion || '',
      });
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  };
